import { Reveal } from "./Reveal";

export const SectionHeading = ({ eyebrow, title, subtitle, testid }) => (
  <Reveal className="mx-auto mb-12 max-w-3xl text-center sm:mb-16">
    {eyebrow && (
      <p className="mb-4 text-xs font-semibold uppercase tracking-[0.3em] text-[#C9A45C]">
        {eyebrow}
      </p>
    )}
    <h2
      data-testid={testid}
      className="font-display text-3xl font-semibold leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl"
    >
      {title}
    </h2>
    {subtitle && (
      <p className="mt-5 text-base leading-relaxed text-[#B8B8B8] sm:text-lg">
        {subtitle}
      </p>
    )}
    <div className="gold-hairline mx-auto mt-8 w-24" aria-hidden="true" />
  </Reveal>
);
